import { Component, OnInit, Input, HostListener, ElementRef, ViewChild, } from '@angular/core';
import { AsbestosisService } from '../../../services/asbestosis.service';
import { GlobalLoadingService } from 'src/app/services/global-loading.service';
import { ActivatedRoute, Router } from '@angular/router';
import { KButtonType } from 'ng-k-button';
import { IKCard, KCardFieldType } from 'ng-k-card';
import * as moment from 'moment';
import { KIconType } from 'ng-k-icon';
import { ClaimsService } from 'src/app/services/claims.service';

enum CausationAdvice {
  ADVICE_FOR_P_LESS_THAN_50 = `The diagnosis of :condition is not secure and we recommend you instruct a Hispathologist.`,
  ADVICE_FOR_P_BTW_50_AND_100 = `The immunohistochemistry profile reveals some markers indicative of :condition, but is missing certain key markers that would make the diagnosis secure.The diagnosis may rest on markers which have a lower probability ratio for :condition and you should re-run the testing having  selected another cancer type and possibly consider instructing a Histopathologist.`,
  ADVICE_FOR_P_GREATER_THAN_100 = `The diagnosis of :condition is reasonably secure.`,
}
@Component({
  selector: 'app-immunohistological-mesothelioma-profile',
  templateUrl: './immunohistological-mesothelioma-profile.component.html',
  styleUrls: ['./immunohistological-mesothelioma-profile.component.scss']
})
export class ImmunohistologicalMesotheliomaProfileComponent implements OnInit {
  @Input() claimId: any;
  @ViewChild('multiSelectDropDown', { static: false }) multiSelectDropDown!: ElementRef;
  public displaySuccess: boolean = false;
  public successText!: string;
  public displayError: boolean = false;
  public errorText!: string;
  public timeout!: number;
  public tabMedical: boolean = false;
  public tabTasks: boolean = false;
  public useCaseName: string = '';
  public adviceLessthan50: any = null;
  public adviceBtw50and100PARA1: any = null;
  public adviceBtw50and100PARA2: any = null;
  public adviceGreaterthan100: any = null;
  public allAntigenMarkers: any = [];
  KButtonType = KButtonType;
  public claimInfo: IKCard = {};
  public claimData: any = [];
  public claimInfo2: IKCard = {};
  public customData: any;




  public causationAdviceObj = {
    ADVICE_FOR_P_LESS_THAN_50: `The diagnosis of :condition is not secure and we recommend you instruct a Hispathologist.`,
    ADVICE_FOR_P_BTW_50_AND_100: {
      PARA1: `The immunohistochemistry profile reveals some markers indicative of :condition, but is missing certain key markers that would make the diagnosis secure.`,
      PARA2: `The diagnosis may rest on markers which have a lower probability ratio for :condition and you should re-run the testing having  selected another cancer type and possibly consider instructing a Histopathologist.`,
    },
    ADVICE_FOR_P_GREATER_THAN_100: `The diagnosis of :condition is reasonably secure.`,
  };

  causationAdvice: any = null;
  public profileId: any = '';

  constructor(
    private asbestosisService: AsbestosisService,
    private loaderService: GlobalLoadingService,
    private router: Router,
    private route: ActivatedRoute,
    private claimsService: ClaimsService,


  ) { }

  async ngOnInit() {
    this.claimId = this.route.snapshot.paramMap.get('claimId')
    if (this.route.snapshot.paramMap.get('profileId')) {
      this.profileId = this.route.snapshot.paramMap.get('profileId')
    }

    let selectAntigens: any = null;
    this.asbestosisService.getAntigenMarkers({ claimId: this.claimId, profileId: this.profileId }).subscribe((result: any) => {
      this.useCaseName = result.data.immunohistologyDetails.useCase;
      if (this.profileId) {
        selectAntigens = result.data.immunohistologyDetails.profiles[0]?.antigenMarkers;
      } else {
        selectAntigens = [];
      }
      if (selectAntigens?.length) {
        selectAntigens.forEach((option: any) => {
          this.selectedOptions.push(option);
        });
      }
      console.log(selectAntigens)
      this.adviceLessthan50 = this.causationAdviceObj.ADVICE_FOR_P_LESS_THAN_50.replace(':condition', this.useCaseName);
      this.adviceBtw50and100PARA2 = this.causationAdviceObj.ADVICE_FOR_P_BTW_50_AND_100.PARA2.replace(':condition', this.useCaseName)
      this.adviceBtw50and100PARA1 = this.causationAdviceObj.ADVICE_FOR_P_BTW_50_AND_100.PARA1.replace(':condition', this.useCaseName);
      this.adviceGreaterthan100 = this.causationAdviceObj.ADVICE_FOR_P_GREATER_THAN_100.replace(':condition', this.useCaseName);
      if (selectAntigens?.length) {
        this.selectedOptions.push(...selectAntigens);
        this.selectedOptions.forEach((option: any) => {
          this.toggleSelection(option);
        });
      }
    });
    await this.fetchAntigenMarkersList();
    this.getWorkflowOverview(this.claimId);
  }
  options: any[] = [];
  filteredOptions: any[] = [];
  selectedOptions: any[] = [];
  dropdownOpen = false;
  searchText = '';
  inputWidth = '100%';
  progress = 0;

  async toggleDropdown() {
    if (!this.allAntigenMarkers.length) {
      await this.fetchAntigenMarkersList();
    }
    this.dropdownOpen = !this.dropdownOpen;
  }

  filterOptions() {
    if (this.searchText) {
      this.dropdownOpen = true;
    } else {
      this.dropdownOpen = false;
    }
    this.filteredOptions = this.options.filter((option) =>
      option?.marker.toLowerCase().includes(this.searchText.toLowerCase())
    );
  }

  isSelected(option: any): boolean {
    const selected = this.selectedOptions.filter((selected) =>
      selected?.marker === option.marker
    );
    return selected.length ? true : false;
  }

  toggleSelection(option: any) {
    if (this.isSelected(option)) {
      this.selectedOptions = this.selectedOptions.filter(
        (selected) => selected.marker !== option.marker
      );
    } else {
      this.selectedOptions.push(option);
    }
    this.findCausationProbability(this.selectedOptions);
    this.updateInputWidth();
  }

  removeSelection(option: any) {
    this.selectedOptions = this.selectedOptions.filter(
      (selected) => selected.marker !== option.marker
    );
    this.findCausationProbability(this.selectedOptions);
    this.updateInputWidth();
  }

  updateInputWidth() {
    const selectedOptionsLength = this.selectedOptions.join(', ').length;
    this.inputWidth = selectedOptionsLength > 20 ? '100%' : 'calc(100% - 10px)';
  }

  findCausationProbability(matchValuesArray: any[]) {
    //find the sum
    //divide by 200
    //convert to percentage (multiply by 100)
    //So basically it is sum/2
    try {
      let sum = 0;
      matchValuesArray.reduce((accum, item: any) => {
        return (sum = accum + item.matchValue);
      }, 0);
      const probabilityPercentage = Math.round(sum / 2);
      this.progress = probabilityPercentage;
      this.causationAdvice = (this.progress < 50) ? this.adviceLessthan50 : (this.progress >= 100) ? this.adviceGreaterthan100 : this.causationAdviceObj;
      this.progress = probabilityPercentage > 100 ? 100 : probabilityPercentage;
    } catch (e) {
      console.log(`Error in calculation`, e)
    }
  }

  public saveImmunohistologicalProfile() {
    const thisObj = this;
    const requestParam: any = {};
    if (this.profileId != '') {
      requestParam.profileId = this.profileId;
    }
    requestParam.claimId = this.claimId;
    requestParam.antigenMarkers = this.selectedOptions.map((item) => {
      return item.marker;
    });


    this.loaderService.startLoadingIndicator('saveImmunohistologicalProfile');
    thisObj.asbestosisService.postSaveAntigenMarker(requestParam).subscribe(
      (result: any) => {
        if (result.status === 'Success') {
          this.loaderService.stopLoadingIndicator(
            'saveImmunohistologicalProfile'
          );
          this.successText = result.data.message;
          this.showMessage('success', 2000);
          setTimeout(() => {
            this.router.navigate(['/claimDetail/', this.claimId, 'medical']);
            this.displaySuccess = false;
          }, 2001);
        }

      },
      (err) => {
        this.loaderService.stopLoadingIndicator('saveImmunohistologicalProfile');
        this.errorText = err.error.message
        this.showMessage('error', 2000);
        setTimeout(() => {
          this.displayError = false;
        }, 2010);
      },
    );
  }

  public editImmunohistologicalProfile() {
    const thisObj = this;
    const requestParam: any = {};
    console.log(this.profileId)
    if (this.profileId != '') {
      requestParam.profileId = this.profileId;

    }
    requestParam.claimId = this.claimId;
    requestParam.antigenMarkers = this.selectedOptions.map((item) => {
      return item.marker;
    });
    this.loaderService.startLoadingIndicator(' editImmunohistologicalProfile');
    this.asbestosisService.getAntigenMarkers(requestParam).subscribe((result: any) => {
      if (result.status === 'Success') {
        this.loaderService.stopLoadingIndicator('editImmunohistologicalProfile');
        this.successText = result.data.message;
        this.showMessage('success', 2000);
        setTimeout(() => {
          this.router.navigate(['/claimDetail/', this.claimId, 'medical']);
          this.displaySuccess = false;
        }, 2001);
      }
    },
      (err) => {
        this.loaderService.stopLoadingIndicator('editImmunohistologicalProfile');
        this.errorText = err.error.message
        this.showMessage('error', 2000);
        setTimeout(() => {
          this.displayError = false;
        }, 2010);
      },
    );
  }

  public showMessage(msgType: any, timeout: any) {
    this.displaySuccess = false;
    if (msgType === 'error') {
      this.displayError = true;
    }
    if (msgType === 'success') {
      this.displaySuccess = true;
    }
    if (timeout) {
      this.timeout = timeout;
    }
  }
  public getWorkflowOverview(claimID: any) {
    const thisObj = this;
    const requestParam: any = {};
    requestParam.claimId = claimID ? claimID : null;
    this.loaderService.startLoadingIndicator('getWorkflowOverview');

    thisObj.claimsService.getWorkflowOverview(requestParam).subscribe(result => {
      if (result.status === 'Success') {
        this.loaderService.stopLoadingIndicator('getWorkflowOverview');


        this.claimData = result.data.meta;
        this.customData = {
          claimId : this.claimId,
          claimantName : this.claimData.claimant.claimantName,
          medicalConditionLabel: 'Mesothelioma',
          medicalConditionValue: 'mesothelioma'
        }
        this.getClaimInfo(this.claimId);
      }

      if (result.status === 'Unprocessable') {
      }
    },
      err => {
        console.log(err.error);
        if (err.error.status === 'Unprocessable') {
          this.loaderService.stopLoadingIndicator('getWorkflowOverview');
          this.claimData = [];
          this.errorText = err.error.Message;
          this.showMessage('error', 2000);

        }
      });
  }

  public getClaimInfo(claimID: any) {
    this.loaderService.startLoadingIndicator('getClaimInfo');
    this.claimInfo = {
      value: '',
      header: {
        label: moment(new Date(this.claimData.claim.createdDate)).format('DD/MM/YYYY'),
        labelColour: 'brand-main',
        icon: {
          type: KIconType.fas,
          name: 'clock'
        }
      },
      clickable: false,
      fields: [
        {
          fieldType: KCardFieldType.IdRef,
          label: 'Claim Reference',
          value: this.claimData?.claimant?.claimReference ? this.claimData?.claimant?.claimReference : ' ',
          icon: {
            type: KIconType.fas,
            name: 'tag',
            border: true
          }
        },
        {
          fieldType: KCardFieldType.Text,
          label: 'Claimant Name',
          value: this.claimData.claimant.claimantName,
          icon: {
            type: KIconType.fas,
            name: 'user',
            border: true
          }
        },
        {
          fieldType: KCardFieldType.Text,
          label: 'Condition',
          value: this.claimData.claimant.condition,
          icon: {
            type: KIconType.fas,
            name: 'stethoscope',
            border: true
          }
        },
        {
          fieldType: KCardFieldType.Link,
          label: 'Open >',
          value: '/claimForm/' + encodeURIComponent(this.claimId),
        }
      ]
    }
    let amountSymbol = ''

    this.claimInfo2 = {
      value: '',
      clickable: false,
      fields: [
        {
          fieldType: KCardFieldType.IdRef,
          label: 'Claim Amount',
          value: this.claimData.claim.claimAmount != 0 ? this.claimData.claim.claimAmount : '0',
          icon: {
            type: KIconType.fas,
            name: 'wallet',
            border: true
          }
        },
        {
          fieldType: KCardFieldType.Text,
          label: 'No. of Defendants',
          value: this.claimData.claim.noOfDefendants ? this.claimData.claim.noOfDefendants : ' ',
          icon: {
            type: KIconType.kennedys,
            name: 'defendant',
            border: true
          }
        },
        {
          fieldType: KCardFieldType.Text,
          label: 'No. of Insurers',
          value: this.claimData.claim.insurersInfo.value + ' Insurer(s)',
          icon: {
            type: KIconType.kennedys,
            name: 'insurer',
            border: true
          }
        },
        {
          fieldType: KCardFieldType.Text,
          label: this.claimData.claim.employersInfo.type == 'name' ? 'Employer name' : 'No. of Employers',
          value: this.claimData.claim.employersInfo.type == 'name' ? (this.claimData.claim.employersInfo.value) : (this.claimData.claim.employersInfo.value + ' Employer(s)'),
          icon: {
            type: KIconType.fas,
            name: 'user-tie',
            border: true
          }
        },
        {
          fieldType: KCardFieldType.Link,
          label: 'Full Apportionment >',
          value: '/claimForm/' + encodeURIComponent(this.claimId),
        }
      ]
    }
    this.loaderService.stopLoadingIndicator('getClaimInfo');
  }
  // Method to generate labels from 0% to 100%
  generateLabels(): number[] {
    const labels = [];
    for (let i = 0; i <= 100; i += 10) {
      labels.push(i);
    }
    return labels;
  }

  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent) {
    const clicked = this.multiSelectDropDown.nativeElement.contains(event.target);
    if (!clicked) this.dropdownOpen = false;
  }

  async fetchAntigenMarkersList() {
    this.loaderService.startLoadingIndicator('fetchAntigenMarkerData');
    this.asbestosisService.getAntigenMarkerValues({}).subscribe((result: any) => {
      result.data?.asbestosImmunoHistologyMap?.forEach((item: any) => {
        if (item.condition === this.useCaseName) {
          item?.antigenMarkers.forEach((antigen: any) => {
            this.options.push(antigen);
            this.filteredOptions.push(antigen);
          });
        }
        this.loaderService.stopLoadingIndicator(
          'fetchAntigenMarkerData'
        );
      });
      this.allAntigenMarkers = [...this.filteredOptions];
      this.findCausationProbability(this.selectedOptions);
    });
  }

  goToPage() {
    this.router.navigate(['/claimDetail/', this.claimId, 'medical']);
  }
}

